module.exports = __webpack_public_path__ + "static/media/02-banner-05-santa-fe@2x.2341566e.jpg";